<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <search-channel-select
        v-model="tableParams.channelId"
        :channelType="100"
      />
      <search-channel-slot-select v-model="tableParams.slotId" :deleted="1" />
      <search-dsp-select v-model="tableParams.dspId" :dspType="100" />
      <search-dsp-slot-select
        v-model="tableParams.dspSlotId"
        :dsp-id="tableParams.dspId"
        :slotIsEnable="false"
      />
      <search-dsp-label-select
        v-model="tableParams.tag"
        :dsp-id="tableParams.dspId"
        @upTag="upTag"
      />
      <search-slot-type-select v-model="tableParams.slotTypeId" />
      <el-select
        v-model="tableParams.settleWay"
        clearable
        placeholder="计费方式"

        style="margin-right: 15px"
      >
        <el-option value="1" label="CPM"></el-option>
        <el-option value="2" label="CPD"></el-option>
        <el-option value="3" label="CPA"></el-option>
      </el-select>
      <el-select
        v-model="tableParams.isRight"
        clearable
        placeholder="对账状态"

      >
        <el-option label="已展示" :value="0"></el-option>
        <el-option label="已对账" :value="1"></el-option>
        <el-option label="未对账" :value="2"></el-option>
      </el-select>
      <search-budget-type v-model="tableParams.budget" />
      <el-date-picker
        v-model="date"
        @change="changeDate"
        style="margin-right: 15px"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        :editable="false"
      >
      </el-date-picker>
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px"
      >
        <!-- <el-upload
          :action="$baseURL + 'report/detail/import/data'"
          :headers="header"
          :show-file-list="false"
          :on-success="onSuccess">
          <el-button
            type="primary"
            size="mini"
            >导入</el-button>
        </el-upload> -->
        <el-button @click="handleShowChange(1)" type="success" size="mini"
          >批量对账</el-button
        >
        <el-button @click="handleShowChange(2)" type="warning" size="mini"
          >批量未对账</el-button
        >
        <el-button
          @click="
            downExcel('/report/detail/list/xlsx', '对账明细', tableParams)
          "
          type="warning"
          size="mini"
          style="margin-left: 10px"
          >下载</el-button
        >
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="showTableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row
        @select-all="handleTableSelectionChange"
        @select="oneChange"
        :summary-method="tableSummary"
        show-summary
        size="small"
        ref="table"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
          align="center"
        >
          <template v-slot="scope">
            <div v-if="v.field === 'showSmtExpected'">
              <div>{{ scope.row.showSmt }}</div>
              <div>{{ scope.row.showSmtExpected }}</div>
            </div>
            <div v-else-if="v.field === 'clkSmtExpected'">
              <div>{{ scope.row.clkSmt }}</div>
              <div>{{ scope.row.clkSmtExpected }}</div>
            </div>
            <div v-else-if="v.field === 'downSmt'">
              <div>{{ scope.row.downSmt }}</div>
              <div>{{ scope.row.downSmtExpected }}</div>
            </div>
            <div v-else-if="v.field === 'expensesExpected'">
              <div>{{ scope.row.expenses }}</div>
              <div>{{ scope.row.expensesExpected }}</div>
            </div>
            <span v-else-if="v.field === 'settleWay'">{{
              settleWayMap[scope.row[v.field]] || "-"
            }}</span>
            <div v-else-if="v.field === 'isRight'">
              <div v-if="scope.row[v.field] == 0">已展示</div>
              <div v-else>
                <el-switch
                  v-model="scope.row[v.field]"
                  @change="(value) => handleRightChange(value, scope.row)"
                  :active-value="1"
                  :inactive-value="2"
                />
              </div>
            </div>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template v-slot="scope" align="center">
            <el-button
              @click="handleSetting(scope.row)"
              type="primary"
              size="mini"
              :disabled="scope.row.isRight == 0 || scope.row.isRight == 1"
              >设置</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60, pagination.total]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>

    <el-dialog
      v-model="dialogStatus"
      :close-on-click-modal="false"
      @close="dialogClose"
      title="扣量设置"
      :width="500"
      append-to-body
    >
      <el-form
        :model="form"
        :rules="rules"
        hide-required-asterisk
        ref="form"

        label-position="left"
      >
        <el-form-item prop="showSmt">
          <template v-slot:label>
            <div class="form-item__label">展示数</div>
          </template>
          <el-input
            v-model="form.showSmt"

            type="number"
            placeholder="请输入展示数"
          />
        </el-form-item>
        <el-form-item prop="clkSmt">
          <template v-slot:label>
            <div class="form-item__label">点击数</div>
          </template>
          <el-input
            v-model="form.clkSmt"

            type="number"
            placeholder="请输入点击数"
          />
        </el-form-item>
        <el-form-item prop="expensesSmt">
          <template v-slot:label>
            <div class="form-item__label">结算金额</div>
          </template>
          <el-input
            v-model="form.expensesSmt"

            placeholder="请输入结算金额"
          />
        </el-form-item>
        <el-form-item prop="remark">
          <template v-slot:label>
            <div class="form-item__label">备注</div>
          </template>
          <el-input
            v-model="form.remark"

            type="textarea"
            autosize
            maxlength="500"
            show-word-limit
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>

      <div style="text-align: right">
        <el-button @click="dialogClose" >取消</el-button>
        <el-button @click="setSubmit" type="primary"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import SearchChannelSelect from '@/components/SearchChannelSelect'
import SearchChannelSlotSelect from '@/components/SearchChannelSlotSelect'
import SearchDspSlotSelect from '@/components/SearchDspSlotSelect'
import SearchDspSelect from '@/components/SearchDspSelect'
import SearchSlotTypeSelect from '@/components/SearchSlotTypeSelect'
import TableColumn from '@/components/TableColumn'
import { formatDate, SIMPLE_MONTH_PATTERN } from '@/util/format'
import initTableMixin from '@/mixins/initTable'
import { downExcelMixin } from '@/mixins/downExcel'
import SearchDspLabelSelect from '@/components/SearchDspLabelSelect'

import { setDeduct, setStatus } from '@/api/manage/account/detail'
import { appTypeMap } from '@/const/app-type'
import SearchBudgetType from '@/components/SearchBudgetType'

const form = {
  channelId: undefined,
  reportDate: undefined,
  reportId: undefined,
  showSmt: undefined,
  expensesSmt: undefined,
  clkSmt: undefined,
  remark: undefined
}

export default {
  name: 'Manage/account/detail',
  components: {
    SearchChannelSelect,
    SearchChannelSlotSelect,
    SearchDspSelect,
    SearchDspSlotSelect,
    SearchSlotTypeSelect,
    TableColumn,
    SearchBudgetType,
    SearchDspLabelSelect
  },
  mixins: [initTableMixin, downExcelMixin],
  data () {
    return {
      columns: [
        { field: 'reportDate', title: '时间' },
        { field: 'slotId', title: '广告位编号' },
        { field: 'slotName', title: '广告位名称' },
        { field: 'channelName', title: '渠道名称' },
        { field: 'dspName', title: 'DSP名称' },
        { field: 'dspSlotName', title: 'DSP广告位名称' },
        { field: 'dspSlotCode', title: 'DSP广告位Code' },
        { field: 'showSmtExpected', title: '展示数' },
        { field: 'clkSmtExpected', title: '点击数' },
        { field: 'expensesExpected', title: '支出' },
        { field: 'settleWay', title: '结算方式' },
        { field: 'setShowName', title: '创建人' },
        { field: 'setShowTime', title: '创建时间' },
        { field: 'remark', title: '备注' },
        { field: 'isRight', title: '对账状态' }
      ],
      date: [new Date(), new Date()],
      header: {},
      appTypeMap,
      dialogStatus: false,
      form: Object.assign({}, form),
      rules: {
        showSmt: [{ required: true, message: '请输入展示数', trigger: 'blur' }],
        clkSmt: [{ required: true, message: '请输入点击数', trigger: 'blur' }],
        expensesSmt: [{ required: true, message: '请输入结算金额', trigger: 'blur' }],
        remark: [{ required: false, trigger: 'blur' }]
      },
      tableSelect: [],
      showTableData: [],
      num: 0,
      timer: null,
      settleWayMap: {
        1: 'CPM',
        2: 'CPD',
        3: 'CPA'
      }
    }
  },
  created () {
    this.header = {
      Authorization: 'Bearer ' + this.access_token,
      responseType: 'blob'
    }
    this.date[0].setMonth(new Date().getMonth(), 0)
    this.date[1].setMonth(new Date().getMonth(), 0)
    this.changeDate(this.date)
  },
  computed: {
    ...mapGetters([
      'access_token'
    ])
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
    this.tableDom()
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/report/detail/select'
      return true
    },
    afterInit (res) {
      this.tableData = res.data.records
      this.tableSelect = []
      document.querySelector('.el-table__body-wrapper').scrollTop = 0
      document.querySelector('.el-table__body').style.transform = 'translateY(0px)'
      const vheight = document.querySelector('#vheight')
      if (this.pagination.pageSize <= 60) {
        vheight.style.height = '0px'
        this.showTableData = this.tableData
        this.timer = true
      } else {
        vheight.style.height = this.tableData.length * 74 + 'px'
        // 截断的前50条数据放入tableData，交给table组件渲染
        this.$nextTick(() => { this.showTableData = this.tableData.slice(0, 50) })
        this.timer = null
      }
    },
    tableDom () {
      const i = document.createElement('i')
      i.id = 'vheight'
      i.style.width = '0'
      i.style.float = 'right'
      const dom = document.querySelector('.el-table__body-wrapper')
      dom.append(i)
      document.querySelector('.el-table__body').style.float = 'left'
      dom.addEventListener('scroll', (v) => {
        const s = dom.scrollTop; const h = 82; let c
        c = Math.floor(s / h) >= this.num && Math.floor(s / h) <= this.num + 30
        if (!this.timer && !c) {
          this.num = Math.floor(s / h)
          if (this.num <= this.pagination.total - 50) {
            document.querySelector('.el-table__body-wrapper .el-table__body').style.transform = `translateY(${s}px)`
            this.showTableData = this.tableData.slice(this.num, this.num + 50)
            this.showTableData.forEach((item) => {
              if (this.tableSelect.indexOf(item) !== -1) {
                this.$nextTick(() => {
                  this.$refs.table.toggleRowSelection(item)
                })
              }
            })
          } else {
            this.num = this.pagination.total - 50
            this.showTableData = this.tableData.slice(this.num, this.num + 50)
            this.showTableData.forEach((item) => {
              if (this.tableSelect.indexOf(item) !== -1) {
                this.$nextTick(() => {
                  this.$refs.table.toggleRowSelection(item)
                })
              }
            })
          }
        }
      })
    },
    changeDate (date) {
      this.tableParams.startTime = date[0] ? formatDate(date[0], SIMPLE_MONTH_PATTERN) : date[0]
      this.tableParams.endTime = date[1] ? formatDate(date[1], SIMPLE_MONTH_PATTERN) : date[1]
    },
    upTag (tag) {
      this.tableParams.tag = tag
    },
    handleTableSelectionChange (selection) {
      if (selection[0]) {
        this.tableSelect = this.tableData
      } else {
        this.tableSelect = []
      }
    },
    oneChange (selection, row) {
      if (this.tableSelect.indexOf(row) !== -1) {
        const data = []
        this.tableSelect.forEach((item) => {
          if (item !== row) {
            data.push(item)
          }
        })
        this.tableSelect = data
      } else {
        this.tableSelect.push(row)
      }
    },
    handleShowChange (status) {
      const data = []
      this.tableSelect.forEach((item) => {
        const obj = {
          channelId: item.channelId,
          reportDate: item.reportDate,
          settleWay: item.settleWay,
          reportId: item.reportId,
          state: status
        }
        data.push(obj)
      })
      this.tableSelect = data
      this.sure(true)
    },
    handleRightChange (value, row) {
      if (!row.reportId) {
        return
      }
      this.tableSelect = [{
        channelId: row.channelId,
        reportDate: row.reportDate,
        settleWay: row.settleWay,
        reportId: row.reportId,
        state: value
      }]
      this.sure(false)
    },

    // onSuccess (res) {
    //   if (res.code === 200) {
    //     this.init()
    //   } else {
    //     this.$message.error(res.msg)
    //   }
    // },
    handleSetting (row) {
      const { channelId, reportDate, reportId, showSmt, expensesExpected, clkSmt, remark } = row
      const expensesSmt = expensesExpected
      this.form = { channelId, reportDate, reportId, showSmt, expensesSmt, clkSmt, remark }
      this.dialogStatus = true
    },
    setSubmit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          setDeduct(this.form).then(res => {
            if (res.code === 200) {
              this.dialogClose()
              this.init()
            }
          })
        }
      })
    },
    resetForm () {
      this.form = Object.assign({}, form)
    },
    dialogClose () {
      this.resetForm()
      this.$refs.form.resetFields()
      this.dialogStatus = false
    },
    sure (renew) {
      let myloading
      if (renew) {
        myloading = this.$loading({
          lock: true,
          text: '正在加载中,请耐心等待',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      }
      setStatus(this.tableSelect).then(res => {
        if (res.code === 200) {
          this.$message.success('对账状态已更新')
          if (renew) {
            myloading.close()
            this.init()
          }
        }
      }).catch(() => {
        this.$message.error('对账状态失败')
        this.init()
      })
    },
    upTag (tag) {
      this.tableParams.tag = tag
    },
    tableSummary () {
      const arr = ['showSmtExpected', 'clkSmtExpected', 'expensesExpected']
      const fixedArr = ['expensesExpected']
      const data = this.tableData
      const checklists = this.checkColumns.map(item => {
        return item.field
      })
      const out = []
      checklists.unshift('')
      for (let i = 0; i < checklists.length; i++) {
        if (i === 0) {
          out[i] = '合计'
        } else {
          if (fixedArr.indexOf(checklists[i]) > -1) {
            out[i] = arr.indexOf(checklists[i]) > -1 ? (data.reduce((total, item) => { return total + Number(item[checklists[i]]) }, 0)).toFixed(4) : '-'
          } else {
            out[i] = arr.indexOf(checklists[i]) > -1 ? data.reduce((total, item) => { return total + Number(item[checklists[i]]) }, 0) : '-'
          }
        }
      }
      return out
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;
  & > * {
    margin-right: 15px;
    margin-bottom: 10px;
    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;
  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
}
.tip {
  color: red;
  text-align: center;
  margin-bottom: 20px;
}
</style>
